var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [_c('div', {
    staticStyle: {
      "font-size": "20px",
      "float": "left",
      "margin": "-40px 0 0 40px",
      "font-weight": "600"
    }
  }, [_vm._v("\n            出差申请-详情")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "float": "right",
      "height": "40px",
      "margin-top": "-40px",
      "margin-right": "40px",
      "background-color": "#006E4B",
      "color": "#FFFFFF",
      "border": "1px solid #006E4B"
    },
    on: {
      "click": _vm.Return
    }
  }, [_vm._v("返回")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "540px",
      "background-color": "white",
      "margin": "75px 40px 0 40px",
      "padding": "100px",
      "overflow-x": "hidden"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0 0 50px 30%"
    }
  }, [_c('el-steps', {
    attrs: {
      "space": 200,
      "active": 1,
      "finish-status": "success"
    }
  }, [_c('el-step', {
    attrs: {
      "title": "发起出差"
    }
  }), _vm._v(" "), _c('el-step', {
    attrs: {
      "title": "审核中"
    }
  }), _vm._v(" "), _c('el-step', {
    attrs: {
      "title": "审核通过"
    }
  })], 1)], 1), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#006E4B",
      "font-weight": "900",
      "font-size": "20px"
    }
  }, [_vm._v("| ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "20px",
      "font-weight": "700"
    }
  }, [_vm._v("基本信息")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "border": "1px solid #DADADA",
      "margin-top": "10px"
    }
  }), _vm._v(" "), _c('el-form', {
    ref: "ruleForm",
    staticClass: "demo-ruleForm",
    attrs: {
      "model": _vm.ruleForm,
      "rules": _vm.rules,
      "label-width": "180px"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "margin-top": "50px"
    },
    attrs: {
      "label": "姓名",
      "prop": "staff_id"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.ruleForm.staff_name) + "\n                        ")])], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "label": "出差事由",
      "prop": "evection_reason"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.ruleForm.evection_reason) + "\n                        ")])], 1)], 1), _vm._v(" "), _vm._l((_vm.ruleForm.evectionTripList), function(item, index) {
    return _c('div', {
      key: index,
      staticStyle: {
        "margin-top": "50px"
      }
    }, [_c('span', {
      staticStyle: {
        "color": "#006E4B",
        "font-weight": "900",
        "font-size": "20px"
      }
    }, [_vm._v("| ")]), _vm._v(" "), _c('span', {
      staticStyle: {
        "font-size": "20px",
        "font-weight": "700"
      }
    }, [_vm._v("行程" + _vm._s(index + 1))]), _vm._v(" "), _c('div', {
      staticStyle: {
        "border": "1px solid #DADADA",
        "margin-top": "10px"
      }
    }), _vm._v(" "), _c('el-row', {
      staticStyle: {
        "margin-top": "50px"
      }
    }, [_c('el-col', {
      attrs: {
        "span": 6
      }
    }, [_c('el-form-item', {
      attrs: {
        "label": "交通工具",
        "prop": "dictionaries_id"
      }
    }, [_vm._v("\n                                " + _vm._s(_vm.evectionTripList[index].dictionaries_data) + "\n                            ")])], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 6
      }
    }, [_c('el-form-item', {
      attrs: {
        "label": "单程往返"
      }
    }, [_vm._v("\n                                " + _vm._s(_vm.evectionTripList[index].trip_type === '1' ? "单程" : "往返") + "\n                            ")])], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 6
      }
    }, [_c('el-form-item', {
      attrs: {
        "label": "出发城市"
      }
    }, [_vm._v("\n                                " + _vm._s(_vm.evectionTripList[index].start_city) + "\n                            ")])], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 6
      }
    }, [_c('el-form-item', {
      attrs: {
        "label": "目的城市"
      }
    }, [_vm._v("\n                                " + _vm._s(_vm.evectionTripList[index].end_city) + "\n                            ")])], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
      attrs: {
        "span": 6
      }
    }, [_c('el-form-item', {
      attrs: {
        "label": "开始时间"
      }
    }, [_vm._v("\n                                " + _vm._s(_vm.evectionTripList[index].start_date) + "\n                            ")])], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 6
      }
    }, [_c('el-form-item', {
      attrs: {
        "label": "结束时间"
      }
    }, [_vm._v("\n                                " + _vm._s(_vm.evectionTripList[index].start_date) + "\n                            ")])], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 6
      }
    }, [_c('el-form-item', {
      staticStyle: {
        "width": "80%"
      },
      attrs: {
        "label": "时长(小时)"
      }
    }, [_vm._v("\n                                " + _vm._s(_vm.evectionTripList[index].trip_duration) + "\n                            ")])], 1)], 1)], 1)
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "50px"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#006E4B",
      "font-weight": "900",
      "font-size": "20px"
    }
  }, [_vm._v("| ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "20px",
      "font-weight": "700"
    }
  }, [_vm._v("同行人")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "border": "1px solid #DADADA",
      "margin-top": "10px"
    }
  }), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, _vm._l((_vm.together_evections), function(item, index) {
    return _c('el-col', {
      key: index,
      attrs: {
        "lg": 4,
        "xl": 2
      }
    }, [_c('div', {
      staticStyle: {
        "height": "36px",
        "width": "60%",
        "padding": "0 10%",
        "background-color": "#ebf4f1"
      }
    }, [_c('span', {
      staticStyle: {
        "line-height": "36px"
      }
    }, [_vm._v(_vm._s(item.staff_name))])])])
  }), 1)], 1)], 2)], 1)], 1)])
}
var staticRenderFns = []
export default { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bc0a1266","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/jcrsgl/Ccsq/Ccsq_edit.vue
// module id = null
// module chunks = 